<template>
  <div class="columns mgt-20px is-multiline">
    <div class="column is-6">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('addAgence.informationsAgences.title')}}
          </p>
        </header>
        <app-info-agence :agence="agence" :societeLibelle="societe.libelle"></app-info-agence>
      </div>
    </div>
    <div class="column is-6">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('addAgence.adresse')}}
          </p>
        </header>
        <div class="card-content">
          <b-field :label="$t('addAgence.adresseIntitule')"></b-field>
          <adresse :adresse="agence.adresse" :afficherIntitule='false'
                   :showLibelle="false"
                   :tableName=SOCIETE></adresse>
        </div>
      </div>
    </div>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('addAgence.infoComplementaire.title')}}
          </p>
        </header>
        <app-info-complementaires :agence="agence"
                                  :societeId="societe.id">
        </app-info-complementaires>
      </div>
    </div>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('addAgence.emailFacturation')}}
          </p>
        </header>
        <div class="card-content">
          <qd-text-editor v-model="agence.emailFacturation" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Adresse from '@/components/general/adresse';
import AppInfoAgence from '@/components/parametrage/agence/InfoAgence';
import AppInfoComplementaires from '@/components/parametrage/agence/infoComplementaires';
import { SOCIETE } from '@/configuration/ville/villeConf';

export default {
  name: 'informationsAgence',
  props: {
    agence: {
      type: Object,
      required: true,
    },
    societe: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      SOCIETE: SOCIETE,
    };
  },
  components: {
    Adresse,
    AppInfoAgence,
    AppInfoComplementaires,
  },
};
</script>

<style scoped>

</style>
